import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineEmail, MdLockOutline, MdArrowForward } from 'react-icons/md';
import AuthFunctions from '../services/AuthService';
import Session from './Session';

export class  Login extends Component {
    static displayName = Login.name;

    state = {
        username: '',
        password: '',
        loggingIn: false,
        usernameMissing: false,
        passwordMissing: false,
        signinFailed: false,
        bannerMessage: null,
    };

    componentDidMount() {
        const stored = sessionStorage.getItem('sessionExpiredMessage');
        if (stored) sessionStorage.removeItem('sessionExpiredMessage');
        const message = this.props.location?.state?.message || stored;
        if (message) this.setState({ bannerMessage: message });
    }

    validate = () => {
        const usernameMissing = this.state.username.trim().length === 0;
        const passwordMissing = this.state.password.trim().length === 0;
        this.setState({ usernameMissing, passwordMissing, signinFailed: false });
        return !usernameMissing && !passwordMissing;
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') this.handleSubmit();
    };

    handleSubmit = async () => {
        if (!this.validate()) return;
        this.setState({ loggingIn: true });
        const tokenData = await AuthFunctions.signInAsync(this.state.username, this.state.password);
        this.setState({ loggingIn: false });
        if (!tokenData?.token) { 
            this.setState({ signinFailed: true });
        } else {
            Session.setUserSession(tokenData.userName, tokenData.token, tokenData.userId, tokenData.userRoles);
            window.location.href = '/';
        }
    };

    render() {
        const { username, password, loggingIn, usernameMissing, passwordMissing, signinFailed, bannerMessage } = this.state;

        return (
            <div className="page-centered">
                <div className="card" style={{ width: '100%', maxWidth: '660px' }}>

                    <div style={{ textAlign: 'left', marginBottom: 'var(--space-xl)' }}>
                        <h4 className="text-h1" style={{ margin: '0 0 var(--space-xs)' }}>Welcome back</h4>
                        <p className="text-default" style={{ margin: 0 }}>
                            Please enter your details to login.
                        </p>
                    </div>

                    {bannerMessage && (
                        <div className="eligibility-success" style={{
                            background: 'rgba(35, 87, 93, 0.08)',
                            border: '1.5px solid var(--brand-primary)',
                            borderRadius: 'var(--radius-sm)',
                            padding: 'var(--space-md)',
                            marginBottom: 'var(--space-lg)',
                            fontSize: 'var(--fs-small)',
                            color: 'var(--brand-primary)',
                            lineHeight: 'var(--lh-snug)',
                        }}>
                            {bannerMessage}
                        </div>
                    )}

                    {signinFailed && (
                        <p className="error-text" style={{ textAlign: 'center', marginBottom: 'var(--space-md)' }}>
                            Username or password is incorrect.
                        </p>
                    )}

                    {/* Email */}
                    <div className='form-group'>
                        <label className="text-label">Enter your email</label>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><MdOutlineEmail size={16} /></span>
                            <input
                                type="text"
                                placeholder="Email"
                                value={username}
                                onChange={(e) => this.setState({ username: e.target.value, usernameMissing: false })}
                                onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    </div>
                    {usernameMissing && <span className="error-text">Email is required.</span>}

                    {/* Password */}
                    <div className='form-group'>
                        <label className="text-label">Enter your password</label>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><MdLockOutline size={16} /></span>
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => this.setState({ password: e.target.value, passwordMissing: false })}
                                onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    </div>
                    {passwordMissing && <span className="error-text">Password is required.</span>}

                    <div style={{ marginTop: 'var(--space-xs)' }}>
                        <button
                            className="btn"
                            disabled={loggingIn}
                            onClick={this.handleSubmit}
                            style={{ width: '100%' }}
                        >
                            {loggingIn ? 'Logging in…' : 'Login'}
                            {!loggingIn && <MdArrowForward size={16} />}
                        </button>
                    </div>

                    <div className="text-small" style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
                        <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
                    </div>

                    <p className="text-small" style={{ textAlign: 'center', margin: 'var(--space-md) 0 0' }}>
                        Don't have an account?{" "}
                        <a href="/signup/eligibility" className="auth-link" style={{ fontWeight: 'var(--weight-semibold)' }}>
                            Get a quote
                        </a>{" "}today
                    </p>

                </div>
            </div>
        );
    }
}